const baseUrl = process.env.REACT_APP_BASE_URL;
console.log({ baseUrl });

export const AuthUrl = {
  signup: baseUrl + "auth/signup",
  signin: baseUrl + "auth/signin",
  refreshToken: baseUrl + "auth/refresh-token",
  username: baseUrl + "auth/",
};

export const RegisterationUrl = {
  register: baseUrl + "course-registrations/",
  requestCallback: baseUrl + "request-callbacks/",
};

export const WebinarUrl = {
  register: baseUrl + "webinars/",
};

export const courseUrl = baseUrl + "courses/";
export const courseEnrollmentsOfUserUrl = baseUrl + "course-enrollments/user/";
export const courseEnrollmentUrl = baseUrl + "course-enrollments/";
export const courseEnrollmentByUserAndIdUrl = (id, userId) =>
  baseUrl + `course-enrollments/${id}/user/${userId}`;

export const createOrderUrl = baseUrl + `payment/create-order`;
export const certificateUrl = baseUrl + "certificates/enrollment/";
export const certificatePublicUrl = (certificateId) =>
  baseUrl + `certificates/${certificateId}/verify`;
